module.exports = __webpack_public_path__ + "static/media/logo-chrome.f2282752.svg";